import { useMemo } from 'react';
import useAuthClient from './useAuthClient';

const useAuthActions = ({state, dispatch}) => {
  const authClient = useAuthClient();

  return useMemo(
    () => ({
      signIn: async (payload) => {
        dispatch({ type: 'USER_LOADING' });

        try {
          const { user, token: jwt } = await authClient.signIn(payload);
          const { id, email, firstName, lastName, sites, siteId, plan, logins, primaryDomain } = user;

          dispatch({ type: 'USER_LOGIN_SUCCEEDED', payload: {
            id,
            firstName,
            lastName,
            email,
            sites,
            siteId,
            plan,
            logins,
            primaryDomain,
            jwt
          }});
        } catch (err) {
          dispatch({ type: 'USER_LOGIN_FAILED' });

          throw err;
        }
      },
      cookieSignIn: async () => {
        dispatch({ type: 'USER_LOADING' });

        try {
          const { user, token: jwt } = await authClient.cookieSignIn();
          const { id, email, firstName, lastName, sites, siteId, plan, logins, primaryDomain } = user;

          dispatch({ type: 'USER_LOGIN_SUCCEEDED', payload: {
            id,
            firstName,
            lastName,
            email,
            sites,
            siteId,
            plan,
            logins,
            primaryDomain,
            jwt
          }});
        } catch (err) {
          dispatch({ type: 'USER_LOGIN_FAILED' });
        }
      },
      signOut: async () => {
        try {
          await authClient.signOut();
        } catch {
          
        }
      },
      signUp: async (payload) => {
        dispatch({ type: 'USER_LOADING' });

        const { user, token: jwt } = await authClient.signUp(payload);
        const { id, email, firstName, lastName, sites, siteId, plan, logins, primaryDomain } = user;
        const signedUp = true;

        dispatch({ type: 'USER_LOGIN_SUCCEEDED', payload: {
          signedUp,
          id,
          firstName,
          lastName,
          email,
          sites,
          siteId,
          plan,
          logins,
          primaryDomain,
          jwt
        }});
      }
    }),
    [dispatch]
  );
}

export default useAuthActions;
